// extracted by mini-css-extract-plugin
module.exports = {"regiser_lead_wrapper":"RegisterLead_regiser_lead_wrapper__3DRH4","title":"RegisterLead_title__bbWBP"};